import {
  formatValueWithMiddlewares,
  checkForNA,
  appendPercentage,
  formatPercentageValue,
  createKpiTileItem,
} from '../../../utils/helper';

export default {
  type: 'KpiTile',
  handler: (data) => {
    const { wasteGenerated, wasteGeneratedPercentageDelta } = data;

    return createKpiTileItem(
      'Waste',
      formatPercentageValue(wasteGenerated),
      wasteGeneratedPercentageDelta
        ? {
            isPositiveValue: wasteGeneratedPercentageDelta >= 0,
            text: formatValueWithMiddlewares(
              Math.abs(wasteGeneratedPercentageDelta),
              [checkForNA, appendPercentage]
            ).toString(),
            sideLabel: '',
            showArrow: wasteGeneratedPercentageDelta !== 0,
          }
        : []
    );
  },
};
